// Toggle Imagen | Video del modo "Crear desde cero", arriba de la caja de
// prompt. Mismo segmented control que el header mobile de InterfazV2
// (:2545-2588) y el PresetDetailSheet (:1686-1723): riel con un indicador
// absoluto que se desliza.
//
// En modo directo decide qué tool se empuja; con "Ayuda de IA" prendida
// viaja como pista al agente (ver directMode.buildOutputKindHintLine).

import React from 'react';
import type { OutputKind } from './directMode';

const OPTIONS: { id: OutputKind; label: string }[] = [
  { id: 'imagen', label: 'Imagen' },
  { id: 'video', label: 'Video' },
];

export const OutputKindToggle: React.FC<{
  value: OutputKind;
  onChange: (k: OutputKind) => void;
  className?: string;
}> = ({ value, onChange, className = '' }) => {
  const idx = value === 'video' ? 1 : 0;
  return (
    <div
      role="tablist"
      aria-label="Tipo de contenido a generar"
      className={`relative inline-grid grid-cols-2 p-0.5 rounded-full bg-white shadow-sm ring-1 ring-black/[0.06] ${className}`}
    >
      {/* Indicador que viaja. `right-1/2` lo deja del ancho de media grilla y
          el translateX(100%) lo lleva a la mitad derecha, sin medir anchos. */}
      <span
        aria-hidden="true"
        className="absolute top-0.5 bottom-0.5 left-0.5 right-1/2 rounded-full bg-brand-primary transition-transform duration-300 ease-out"
        style={{ transform: `translateX(${idx * 100}%)` }}
      />
      {OPTIONS.map((opt) => {
        const active = opt.id === value;
        return (
          <button
            key={opt.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.id)}
            className={`relative z-10 inline-flex items-center justify-center px-5 h-8 rounded-full text-[14px] font-semibold transition-colors duration-300 ${
              active ? 'text-white' : 'text-[rgb(var(--brand-black-rgb)_/_0.65)]'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default OutputKindToggle;
